module.exports = __webpack_public_path__ + "static/media/Statua_039.3fc22d10.jpg";